module.exports = __webpack_public_path__ + "static/media/decompose-btn.65c0a343.svg";